import { useHandleErrorBase } from "@roman/shared/hooks/useHandleErrorBase";
import { toast } from "sonner";

export const useHandleError = (message = "") => {
  return useHandleErrorBase(message, toast);
};
